import { CertUpload } from "@/features/workers/ui/CertUpload";
import { PhotoUpload } from "@/features/workers/ui/PhotoUpload";
import { WorkerProfileForm } from "@/features/workers/ui/WorkerProfileForm";
import { useWorkerProfile } from "@/features/workers/model/useWorkerProfile";

const STATUS_LABELS: Record<string, string> = {
  PENDING: "Pending approval",
  APPROVED: "Approved",
  SUSPENDED: "Suspended",
};

export function WorkerProfileView() {
  const { data: profile, isLoading, error } = useWorkerProfile();

  if (isLoading) return <div className="text-sm text-muted-foreground">Loading profile...</div>;
  if (error || !profile) return <div className="text-sm text-destructive">Could not load profile.</div>;

  return (
    <div className="space-y-8">
      <section className="rounded-lg border bg-card p-6 shadow-sm">
        <div className="mb-4 flex items-center justify-between">
          <h2 className="text-lg font-semibold">Profile photo</h2>
          <span className="rounded-full bg-secondary px-2 py-1 text-xs font-medium">
            {STATUS_LABELS[profile.status] ?? profile.status}
          </span>
        </div>
        <PhotoUpload photoUrl={profile.photo_url} />
      </section>

      <section className="rounded-lg border bg-card p-6 shadow-sm">
        <h2 className="mb-4 text-lg font-semibold">Details</h2>
        <WorkerProfileForm profile={profile} />
      </section>

      <section className="rounded-lg border bg-card p-6 shadow-sm">
        <h2 className="mb-4 text-lg font-semibold">Certifications</h2>
        <CertUpload certifications={profile.certifications} />
      </section>
    </div>
  );
}
